import React, { useState, useEffect } from "react";
import arrowNext from "../../images/arrowNext.svg";
import amaxLogo from "../../images/amaxLogoWhite.png";
import { Link, useNavigate } from "react-router-dom";

const AthleteStep5 = () => {
  const navigate = useNavigate();

  const [heightFeet, setHeightFeet] = useState("");
  const [heightInches, setHeightInches] = useState("");
  const [weight, setWeight] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    // Restore saved values
    const heightFeet_ = sessionStorage.getItem("heightFeet");
    const heightInches_ = sessionStorage.getItem("heightInches");
    const weight_ = sessionStorage.getItem("weight");

    if (heightFeet_) setHeightFeet(heightFeet_);
    if (heightInches_) setHeightInches(heightInches_);
    if (weight_) setWeight(weight_);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!heightFeet || !heightInches || !weight) {
      setError("Please enter your full height and weight");
      return;
    }

    setError(null);
    sessionStorage.setItem("heightFeet", heightFeet);
    sessionStorage.setItem("heightInches", heightInches);
    sessionStorage.setItem("weight", weight);

    navigate("/athlete/register/step6");
  };

  return (
    <div className="p-[20px] bg-white h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>

        <div className="flex flex-col gap-12 w-full">
          <div>
            <div className="flex flex-col justify-center gap-4">
              <h1 className="text-black text-3xl xs:text-4xl leading-tight font-light uppercase mb-0.5">
                ATHLETE
                <br />
                <span className="text-4xl xs:text-5xl leading-tight font-bold">PROFILE</span>
              </h1>

              {/* HEIGHT INPUT */}
              <div className="flex flex-col gap-[10px]">
                <label className="text-black text-lg ml-2">
                  Height
                </label>
                <div className="flex gap-[10px]">
                  <input
                    type="number"
                    min="0"
                    placeholder="Feet"
                    className="w-1/2 border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                    value={heightFeet}
                    onChange={(e) => setHeightFeet(e.target.value)}
                  />
                  <input
                    type="number"
                    min="0"
                    max="11"
                    placeholder="Inches"
                    className="w-1/2 border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                    value={heightInches}
                    onChange={(e) => setHeightInches(e.target.value)}
                  />
                </div>
              </div>

              {/* WEIGHT INPUT */}
              <div className="flex flex-col gap-[10px] mt-[15px]">
                <label className="text-black text-lg ml-2">
                  Weight (lbs)
                </label>
                <input
                  type="number"
                  min="0"
                  placeholder="Enter weight"
                  className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                />
              </div>
            </div>

            {/* ERROR MESSAGE */}
            {error && (
              <p className="text-red-500 text-sm text-center mt-5">{error}</p>
            )}
          </div>

          {/* NEXT BUTTON */}
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-black size-12 xs:size-14 rounded-full flex justify-center items-center hover:bg-black/70 transition-all duration-300 ml-auto mt-[10px]"
          >
            <img
              src={arrowNext}
              alt="arrow"
              className="object-contain invert max-w-5 xs:max-w-6 "
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AthleteStep5;
